
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import {mapActions, mapGetters, mapState} from 'vuex';
    import EingetragenAmVom from '@/components/EingetragenAmVom.vue';
    import Untersuchung from '@/types/Untersuchung';
    import { confirmSwal } from '@/helper/swals';
    import { SweetAlertResult } from 'sweetalert2';
    import {VCurrencyField, VForm} from '@/types/Components';
    import { DeleteUntersuchungPayload, UntersuchungenFilter, UpdateUntersuchungPayload } from '@/store/untersuchungen';

    @Component({
        components: {
            EingetragenAmVom,
        },
        computed: {
            ...mapState('globals', ['rules']),
            ...mapState('untersuchungen', ['loaders', 'befundvarianten']),
            ...mapGetters('authentication', ['getSystemEinstellung']),
        },
        methods: {
            ...mapActions('untersuchungen', ['loadUntersuchungen', 'updateUntersuchung', 'deleteUntersuchung']),
        },
    })
    export default class UntersuchungenDetail extends Vue {
        @Prop() visible!: boolean;
        @Prop() untersuchung!: Untersuchung;
        @Prop() filter!: UntersuchungenFilter;

        public $refs!: {
            form: VForm;
            preis: VCurrencyField;
            preis_mitarbeiter: VCurrencyField;
            preis_rektorat: VCurrencyField;
        };

        public updateUntersuchung!: (payload: UpdateUntersuchungPayload) => void;
        public deleteUntersuchung!: (payload: DeleteUntersuchungPayload) => void;

        public defaultPreis = 0;

        public get isEdit(): boolean {
            return this.untersuchung.untersuchung_id !== null;
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                if (this.$refs.form) {
                    this.$refs.form.resetValidation();
                }

                this.defaultPreis = this.untersuchung.preis ?? 0;
            }
        }

        public onClickSave(): void {
            if (this.$refs.form.validate()) {
                this.updateUntersuchung({ untersuchung: this.untersuchung, filter: this.filter });
            }
        }

        public onClickDelete(): void {
            confirmSwal('Löschen', 'Untersuchung endgültig löschen?', 'Löschen', 'Abbrechen')
                .then(({ isConfirmed }: SweetAlertResult) => {
                    if (isConfirmed) {
                        this.deleteUntersuchung({ untersuchung: this.untersuchung, filter: this.filter });
                    }
                });
        }
    }
